import React from 'react';
import { CheckCircle, AlertTriangle, XCircle, RefreshCw } from 'lucide-react';

export const STATUS_ICON = {
  ok:    <CheckCircle size={16} color="#22c55e" />,
  warn:  <AlertTriangle size={16} color="#f59e0b" />,
  error: <XCircle size={16} color="#ef4444" />,
};

export function SectionLabel({ children, theme, action }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: theme.textMuted, fontFamily: 'monospace', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
        {children}
      </div>
      {action}
    </div>
  );
}

export function RefreshBtn({ onClick, loading, theme, label = 'Refresh' }) {
  return (
    <button onClick={onClick} disabled={loading} style={{
      display: 'flex', alignItems: 'center', gap: 5,
      padding: '5px 12px', borderRadius: 6, fontSize: 12, fontWeight: 500,
      background: 'transparent', border: `1px solid ${theme.border}`,
      color: theme.textMuted, cursor: loading ? 'not-allowed' : 'pointer',
      opacity: loading ? 0.5 : 1,
    }}>
      <RefreshCw size={12} style={{ animation: loading ? 'gr-spin 0.8s linear infinite' : 'none' }} />
      {label}
    </button>
  );
}

export function EmptyChart({ theme }) {
  return (
    <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: theme.textMuted }}>
      No data yet
    </div>
  );
}

export function chartOptions(theme, overrides = {}) {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: { ticks: { color: theme.textMuted, font: { size: 11 } }, grid: { color: theme.border } },
      y: { beginAtZero: true, ticks: { precision: 0, color: theme.textMuted, font: { size: 11 } }, grid: { color: theme.border } },
    },
    ...overrides,
  };
}

export function formatDate(str) {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function timeAgo(dateStr) {
  if (!dateStr) return 'never';
  const s = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (s < 60)    return `${s}s ago`;
  if (s < 3600)  return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function lagColor(ms) {
  if (ms == null) return '#6c757d';
  if (ms < 5)    return '#22c55e';
  if (ms < 20)   return '#f59e0b';
  return '#ef4444';
}

export function heapColor(pct) {
  if (pct == null) return '#6c757d';
  if (pct < 50)   return '#22c55e';
  if (pct < 75)   return '#f59e0b';
  return '#ef4444';
}
